import { BaseAsyncValue } from '../../../shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { jobsitesWithPreload } from '../../selectors/one-click-jobsites.selector';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { renderLocationDesc } from '../../helpers/utilities';

export namespace OneClickLocationProvider {
  export class TextPreview extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      return this.store.select(getOneClickSelectedOrder).pipe(
        filter(order => !!order),
        map(order => renderLocationDesc(order)),
      );
    }
  }

  export class TextBuilder extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      return this.store.select(jobsitesWithPreload).pipe(
        filter(({ preloadedOrder }) => !!preloadedOrder),
        map(({ preloadedOrder }) => renderLocationDesc(preloadedOrder)),
      );
    }
  }
}
